import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';

import { RouterOutlet } from '@angular/router';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

import { MemberRemoveComponent } from '../../tools/member-remove/member-remove.component';
import { ConfirmDialogComponent } from '../../tools/confirm-dialog/confirm-dialog.component';
import { EditSubsAdminComponent } from '../../tools/edit-subs-admin/edit-subs-admin.component';
import { ModalCancelSubscriptionComponent } from '../../tools/modal-cancel-subscription/modal-cancel-subscription.component';
import { UsuarioService } from '../../services/usuario.service';
import { FacadeService } from '../../services/facade.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { ProyectosService } from '../../services/proyectos.service';
import { environment } from '../../../environments/environment';

import { ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';

import { isPlatformBrowser } from '@angular/common';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { stringify } from 'node:querystring';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms'; // For FormGroup
import { MatNativeDateModule } from '@angular/material/core'; // For native Date adapter

import { loadStripe, Stripe } from '@stripe/stripe-js';


@Component({
  selector: 'api-update',
  standalone: true,
  imports: [CommonModule,
    RouterOutlet,
    MatTableModule,
    MatDialogModule,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatPaginatorModule,
    FormsModule,
    BaseChartDirective,
    HttpClientModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    OverlayModule,
    MatDatepickerModule,
    MatTooltipModule],
  templateUrl: './api-update.component.html',
  styleUrl: './api-update.component.css'
})
export class ApiUpdateComponent implements OnInit {




  constructor(
    public dialog: MatDialog,
    private userService: UsuarioService,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private location: Location,
  ) {
  }

  currentPlan: any = null;
  currentPlanValue = 200;

  plans = [
    { id: 0, calls: '200', price: 'Free / month', value: 200 },
    { id: 1, calls: '1,400', price: '£360 / year', value: 1400 },
    { id: 2, calls: '2,800', price: '£720 / year', value: 2800 },
    { id: 3, calls: '25,200', price: '£2,880 / year', value: 25200, current: true },
    { id: 4, calls: '50,000', price: '£5,760 / year', value: 50000 },
    { id: 5, calls: '100,000', price: '£11,520 / year', value: 100000 },
    { id: 6, calls: '200,000', price: '£23,040 / year', value: 200000 },
    { id: 7, calls: '500,000', price: '£57,600 / year', value: 500000, new: true }
  ];


  selectedPlan: any = null;

  isDisabled(plan: any): boolean {
    return plan.value <= this.currentPlanValue;
  }

  isActive(plan: any): boolean {
    // Activo si es el plan actual
    if (this.isCurrent(plan)) {
      return true;
    }

    // Activo si es el nuevo plan seleccionado
    if (this.selectedPlan?.id === plan.id) {
      return true;
    }

    return false;
  }


  isCurrent(plan: any): boolean {
    return plan.value === this.currentPlanValue;
  }


  selectPlan(plan: any) {
    if (this.isDisabled(plan)) {
      return;
    }

    this.resetStripeCheckout();

    this.selectedPlan = plan;
  }

  getPlanTransactionId(): number {
    if (!this.selectedPlan) {
      return 0;
    }
    return 100 + this.selectedPlan.id;
  }


  // Stripe
  stripe!: Stripe;
  checkout: any;

  // UI state
  loading = false;
  showError = false;
  errorMessage = '';

  seleccionado = 0;
  planes = ['price_123']; // ejemplo

  async ngOnInit(): Promise<void> {
    this.stripe = await loadStripe('pk_test_51KvMbXLNHQSXo9NbhXSLhfk1yzbhOxnjgGNnhH9S94covoS0pVmaZmJyM0ly4shqdIrjNirvKnk33xyqFWDCOftI00rIuWvTAI') as Stripe;
    this.currentPlan = this.plans.find(p => p.value === this.currentPlanValue) || null;
    this.setCurrentPlanFromStorage();
  }

  ngOnDestroy(): void {
    if (this.checkout) {
      try {
        this.checkout.destroy();
      } catch (e) { }
      this.checkout = null;
    }
  }

  setCurrentPlanFromStorage(): void {
    const nameSubs = localStorage.getItem('name_subs');

    if (!nameSubs) {
      return;
    }

    // Validar que sea un plan de API Calls
    if (!nameSubs.toLowerCase().includes('api calls')) {
      return;
    }

    // Extraer el primer número (con o sin comas)
    const match = nameSubs.match(/^([\d,]+)/);

    if (!match) {
      return;
    }

    const value = Number(match[1].replace(/,/g, ''));

    if (isNaN(value)) {
      return;
    }

    this.currentPlanValue = value;

    this.currentPlan = this.plans.find(p => p.value === value) || null;
  }

  isRadioActive(plan: any): boolean {
    if (this.isCurrent(plan)) {
      return true;
    }

    if (this.selectedPlan?.id === plan.id) {
      return true;
    }

    return false;
  }

  checkoutInitialized = false;


  iniciarPagoStripe(): void {
    if (this.loading || this.checkoutInitialized) {
      return;
    }

    if (!this.selectedPlan) {
      this.mostrarError('Please select a new plan first');
      return;
    }

    console.log('Si esta entrando Log normal');

    this.loading = true;
    this.showError = false;

    const token = localStorage.getItem('text_UID');
    console.log(token);
    const planTransactionId = this.getPlanTransactionId();

    fetch(`${environment.text_v1}/api/v2/getTransactionID_NoCookie/${planTransactionId}`, {
      method: 'GET',
      headers: {
        'Authorization': token
      }
    })
      .then(res => res.json())
      .then(datos => {

        // Usuario en organización
        if (datos.info?.startsWith('Your account is currently associated with an organisation')) {
          this.mostrarError(
            'Your account is currently associated with an organisation. ' +
            'The organisation leader must remove you first.'
          );
          return;
        }

        // Ya tiene subscripción activa
        if (datos.info?.startsWith('You currently have an active subscription')) {
          this.mostrarError(
            'You currently have an active subscription. Cancel it first.'
          );
          return;
        }

        // Crear checkout
        console.log(datos)
        this.crearCheckoutStripe(
          datos.transaction_id,
          datos.hostname,
          datos.stripe_client,
          datos.stripe_price
        );
      })
      .catch(err => {
        console.error(err);
        this.mostrarError('Unexpected error');
      });
  }

  // Mostrar error en pantalla
  mostrarError(msg: string): void {
    this.showError = true;
    this.errorMessage = msg;
    this.loading = false;
  }

  // Crear sesión de checkout en tu backend
  crearCheckoutStripe(
    transactionId: string,
    host: string,
    stripeClient: string,
    stripePrice: string
  ): void {

    const data = {
      line_items: [
        { price: stripePrice, quantity: 1 }
      ],
      metadata: { transaction: transactionId },
      customer: stripeClient,
      mode: 'subscription',
      ui_mode: 'embedded',
      return_url: `https://${host}/paypal/stripe/success/${transactionId}`,
      locale: 'en'
    };

    var formData = new URLSearchParams();

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (Array.isArray(data[key])) {
          // Verificar si es un array de objetos
          if (data[key].length > 0 && typeof data[key][0] === 'object') {
            for (var i = 0; i < data[key].length; i++) {
              var item = data[key][i];
              for (var subKey in item) {
                if (item.hasOwnProperty(subKey)) {
                  formData.append(key + '[' + i + '][' + subKey + ']', item[subKey]);
                }
              }
            }
          } else {
            // Si es un array pero no es de objetos, agregar directamente al formulario
            formData.append(key, "[\"" + data[key] + "\"]");
          }
        } else {
          if (typeof data[key] === 'object' && data[key] !== null) {
            // Si es un objeto, iterar sobre sus claves y agregarlas con el prefijo adecuado
            for (const subclave in data[key]) {
              formData.append(`${key}[${subclave}]`, data[key][subclave]);
            }
          } else {
            // Si no es un objeto, agregar la clave y su valor al objeto URLSearchParams
            formData.append(key, data[key]);
          }
        }
      }
    }

    fetch(`${environment.text_v1}/api/v2/createCheckout`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ checkout: formData.toString() })
    })
      .then(res => res.json())
      .then(data => {
        this.montarStripe(data.client_secret);
      })
      .catch(err => {
        console.error(err);
        this.mostrarError('Stripe checkout error');
      });
  }

  resetStripeCheckout(): void {
    this.checkoutInitialized = false;
    this.showError = false;

    if (this.checkout) {
      try {
        if (typeof this.checkout.destroy === 'function') {
          this.checkout.destroy();
        } else if (typeof this.checkout.unmount === 'function') {
          this.checkout.unmount();
        }
      } catch (e) {
        console.warn('Stripe checkout already destroyed');
      }

      this.checkout = null;
    }

    const checkoutEl = document.getElementById('checkout');
    if (checkoutEl) {
      checkoutEl.innerHTML = '';
    }
  }




  async montarStripe(clientSecret: string): Promise<void> {
    try {
      if (this.checkout) {
        this.checkout.unmount();
      }

      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret
      });

      this.checkout.mount('#checkout');
      this.checkoutInitialized = true;
    } catch (error) {
      console.error(error);
      this.mostrarError('Stripe checkout error');
    } finally {
      this.loading = false;
    }
  }

  goBack() {
    if (
      isPlatformBrowser(this.platformId) &&
      window.location.pathname === '/upgrade-api-subcribe' &&
      window.history.length > 1
    ) {
      this.location.back();
      return;
    }

    this.proyectoService.updateprofilePage(true);
  }
}
